import React, { Component } from 'react'
import Subtitle from '../../sub-title'
import { Link } from 'gatsby'
import eventsImage from '../../images/main-characteristics/events'
import plannedImage from '../../images/main-characteristics/planned'
import singersImage from '../../images/main-characteristics/singers'
import socialImage from '../../images/main-characteristics/social'
import styles from './AlternatingList.module.css'

const imgWraper = WrappedComponent => (
  <WrappedComponent className={styles.imageContainer} />
)

const items = [
  {
    title: 'Wide experience in organizing cultural events',
    description:
      // 'We organized events for Indian Armed Forces, Government Organizations, Corporate Houses, and many reputed clubs',
      'We organized events for Indian Armed Forces, Government Organizations, Corporate Houses, etc',

    link: {
      route: '#', // events
      description: 'Past and upcoming events',
    },
    image: eventsImage,
  },
  {
    title: 'Meticulous planning',
    description: 'Carefully chosen song selection, and program planning',
    link: {
      route: '#', // services
      description: 'Our services',
    },
    image: plannedImage,
  },
  {
    title: 'Extremely talented artists',
    description: 'Each event brings high quality artists',
    link: {
      route: '#', // artists
      description: 'Artists details',
    },
    image: singersImage,
  },
  {
    title: 'Always associated with social causes',
    description: 'We focus on spreading awareness on social issues',
    link: {
      route: '#', // social
      description: 'Social impact stories',
    },
    image: socialImage,
  },
  // {
  //   title: 'All over India',
  //   description:
  //     'Various cities like Delhi, Mumbai, Pune, Ahmedabad, Baroda and Bengaluru',
  //   image: SingersImage,
  // },

  // {
  //   title: 'Loyal and enthusiastic audience',
  //   description:
  //     'From all over the country and abroad, our audience is very appreciative of our exclusive shows',
  //   image: SingersImage,
  // },
]

const Item = ({ item: { title, description, link, image } }) => (
  <article key={title} className={styles.itemContainer}>
    {imgWraper(image)}
    {/* <ProfileImage className={styles.profileImage} /> */}
    {/* <img src="" className={styles.image}></img> */}
    <div className={styles.itemBody}>
      <Subtitle>{title}</Subtitle>
      <p className={styles.description}>{description}</p>
      {link && (
        <span className={styles.link} to={link.route} disabled>
          {link.description}
        </span>
      )}
    </div>
  </article>
)

export class AlternatingList extends Component {
  render() {
    return (
      <div className={styles.container}>
        {items.map(item => (
          <Item item={item} />
        ))}
      </div>
    )
  }
}

export default AlternatingList
